module.exports = __webpack_public_path__ + "static/media/logo-with-name.db6e71c0.svg";